export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14505.92bcd271.jpg";